import { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "./Logo";

const links = [
  { href: "#configurateur", label: "Configurateur" },
  { href: "#rdv-devis", label: "Devis gratuit" },
  { href: "#realisations", label: "Réalisations" },
  { href: "#about", label: "À propos" },
  { href: "#avis", label: "Avis" },
  { href: "#diagnostic", label: "Diagnostic IA" },
  { href: "#contact", label: "Contact" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "glass-strong py-3"
          : "bg-transparent py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex items-center gap-3 group"
        >
          <Logo className="h-12 md:h-14 w-auto object-contain" />
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm text-neutral-300 hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2 md:gap-3">
          {/* Téléphone — TRÈS visible : gros sur desktop, compact mais visible sur mobile */}
          <a
            href="tel:+33763433867"
            data-testid="nav-call-btn"
            aria-label="Appeler GMC Rénovation Façade"
            className="hidden md:flex items-center gap-2.5 px-4 py-2.5 rounded-full bg-[#FF5A00]/10 border border-[#FF5A00]/40 hover:bg-[#FF5A00]/20 hover:border-[#FF5A00] transition-all group"
          >
            <span className="relative flex h-7 w-7 items-center justify-center rounded-full bg-[#FF5A00]">
              <Phone size={14} className="text-white" />
            </span>
            <span className="flex flex-col leading-tight">
              <span className="text-[10px] uppercase tracking-[0.15em] text-[#FF5A00] font-semibold">
                Appeler
              </span>
              <span className="text-base font-display text-white whitespace-nowrap">
                07 63 43 38 67
              </span>
            </span>
          </a>

          {/* Mobile : pill compact avec numéro toujours visible */}
          <a
            href="tel:+33763433867"
            data-testid="nav-call-btn-mobile"
            aria-label="Appeler GMC"
            className="md:hidden flex items-center gap-1.5 px-3 py-2 rounded-full bg-[#FF5A00] text-white text-[13px] font-semibold whitespace-nowrap active:scale-95 transition-transform"
          >
            <Phone size={14} className="shrink-0" />
            <span>07 63 43 38 67</span>
          </a>

          <a
            href="#contact"
            data-testid="nav-cta-btn"
            className="btn-primary hidden md:inline-flex text-sm"
          >
            Devis gratuit
          </a>
          <button
            data-testid="nav-mobile-toggle"
            className="md:hidden p-2 text-white"
            onClick={() => setOpen(!open)}
            aria-label="Menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden glass-strong border-t border-white/5"
        >
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-link-${l.label.toLowerCase()}`}
                className="text-base text-neutral-200"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="btn-primary mt-2"
              data-testid="mobile-cta"
            >
              Demander un devis
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
